An array of synchronization errors for positions that could not be processed.

This will be null if all positions were synced successfully.
